import dayjs from 'dayjs';

import { pacific } from '../theme/colors';
import { Schedule, Task, TaskStatus } from '../types/task';

const STATUS_COLOR = {
  [TaskStatus.ERROR]: '#ffc8c8',
  [TaskStatus.COMPLETED]: '#bbf7d0',
  [TaskStatus.PENDING]: pacific.main,
};

export const getExpectedRuns = (task: Task) => {
  const start = new Date(task.date);
  const end = new Date(start);

  switch (task.schedule) {
    case Schedule.EVERY_MINUTE:
    case Schedule.HOURLY:
      return 5;
    case Schedule.DAILY:
      end.setMonth(end.getMonth() + 3);
      return Math.floor((end.getTime() - start.getTime()) / (24 * 60 * 60 * 1000));
    case Schedule.WEEKLY:
      end.setMonth(end.getMonth() + 3);
      return Math.floor((end.getTime() - start.getTime()) / (7 * 24 * 60 * 60 * 1000));
    case Schedule.MONTHLY:
      return 3;
    default:
      return 1;
  }
};

export const generateRecurringEvents = (task: Task) => {
  const events = [];
  const taskStartDate = new Date(task.date);
  const now = new Date();

  const endDate = new Date(taskStartDate);

  switch (task.schedule) {
    case Schedule.EVERY_MINUTE:
      endDate.setMinutes(endDate.getMinutes() + 5);
      break;
    case Schedule.HOURLY:
      endDate.setHours(endDate.getHours() + 5);
      break;
    case Schedule.DAILY:
    case Schedule.WEEKLY:
    case Schedule.MONTHLY:
      endDate.setMonth(endDate.getMonth() + 3);
      break;
    default:
      endDate.setMonth(endDate.getMonth() + 1);
      break;
  }

  const expectedRuns = getExpectedRuns(task);
  const actualRuns = task.result_count;

  const isActuallyPending =
    task.status === TaskStatus.PENDING ||
    (task.status === TaskStatus.COMPLETED && actualRuns < expectedRuns);

  if (isActuallyPending) {
    let currentDate = new Date(now);

    while (currentDate <= endDate) {
      const scheduleTime = task.schedule_at.schedule_time && dayjs(task.schedule_at.schedule_time);

      const startTime = scheduleTime
        ? dayjs(currentDate)
            .hour(scheduleTime.hour())
            .minute(scheduleTime.minute())
            .second(0)
            .millisecond(0)
            .toDate()
        : Schedule.EVERY_MINUTE
          ? dayjs(currentDate).add(1, 'minute').toDate()
          : Schedule.HOURLY
            ? dayjs(currentDate).add(1, 'hour').toDate()
            : currentDate;

      events.push({
        title: `${task.agent_name}: ${task.instruction} (${TaskStatus.PENDING})`,
        start: startTime,
        end: dayjs(startTime).add(5, 'minute').toDate(),
        id: Date.now() + Math.random(),
        taskId: task.id,
        status: TaskStatus.PENDING,
        color: STATUS_COLOR[TaskStatus.PENDING],
        textColor: '#484655',
      });

      switch (task.schedule) {
        case Schedule.NOW:
          currentDate = new Date(endDate.getTime() + 1);
          break;
        case Schedule.EVERY_MINUTE:
          currentDate = new Date(currentDate.getTime() + 60 * 1000);
          break;
        case Schedule.HOURLY:
          currentDate = new Date(currentDate.getTime() + 60 * 60 * 1000);
          break;
        case Schedule.DAILY:
          currentDate.setDate(currentDate.getDate() + 1);
          break;
        case Schedule.WEEKLY:
          currentDate.setDate(currentDate.getDate() + 7);
          break;
        case Schedule.MONTHLY:
          currentDate.setMonth(currentDate.getMonth() + 1);
          break;
        default:
          currentDate = new Date(endDate.getTime() + 1);
          break;
      }
    }
  } else {
    events.push({
      title: `${task.agent_name}: ${task.instruction} (${task.status})`,
      start: taskStartDate.toISOString().split('T')[0],
      id: Date.now() + Math.random(),
      taskId: task.id,
      status: task.status,
      color: STATUS_COLOR[task.status],
      textColor: '#484655',
    });
  }

  return events;
};
